import { z } from "zod";

export const getCreationTemplateFormSchema = z.object({
  accountId: z.string().trim().min(1, "formData.forms.errors.required"),
  walletId: z.string().trim().min(1, "formData.forms.errors.required"),
  ledgerTypeId: z.string().trim().min(1, "formData.forms.errors.required"),
});

export type GetCreationTemplateFormType = z.infer<
  typeof getCreationTemplateFormSchema
>;
